import React, { forwardRef } from "react";
import { chakra, useMultiStyleConfig } from "@chakra-ui/react";
function SelectOptionsInner({ children, virtualizer, virtualItems }, ref) {
    const styles = useMultiStyleConfig("SelectOptions");
    return (React.createElement(chakra.div, { ref: ref, __css: styles["container"] },
        React.createElement(chakra.div, { __css: styles["list"], style: {
                height: `${virtualizer.getTotalSize()}px`,
            } }, virtualizer.getVirtualItems().map(({ key, index, start }) => {
            const virtualItem = virtualItems[index];
            return (React.createElement(chakra.div, { key: key, __css: styles["item"], style: {
                    transform: `translateY(${start}px)`,
                } }, children(virtualItem, index)));
        }))));
}
// `forwardRef` doesn't support props with generics, so here's an ugly workaround
// See https://fettblog.eu/typescript-react-generic-forward-refs/
export const SelectOptions = forwardRef(SelectOptionsInner);
